import { render, staticRenderFns } from "./VaultSetupAnotherDevice.vue?vue&type=template&id=23730d78&scoped=true"
import script from "./VaultSetupAnotherDevice.vue?vue&type=script&lang=js"
export * from "./VaultSetupAnotherDevice.vue?vue&type=script&lang=js"
import style0 from "./VaultSetupAnotherDevice.vue?vue&type=style&index=0&id=23730d78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23730d78",
  null
  
)

export default component.exports